import React, { ReactNode } from "react";
import classnames from "classnames";
import Styles from "./ServiceInformation.module.scss";

interface ServiceInformationProps {
    heading: string;
    sectionTitle: string;
    sectionText?: string;
    descriptionComponent?: ReactNode;
}

const ServiceInformation = ({
    sectionTitle,
    sectionText,
    heading,
    descriptionComponent: descriptionComponent
}: ServiceInformationProps) => {
    return (
        <section className={classnames(Styles.main)}>
            <div className={classnames("container")}>
                <div className={Styles.heading}>
                    <h1>{heading}</h1>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                    {!!descriptionComponent ? descriptionComponent : null}
                </div>
            </div>
        </section>
    );
};

export default ServiceInformation;
